import { cn } from '@wellesley/ui'
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { ReactNode, useState } from 'react'

type SideBarSize = 'sm' | 'lg'

export type SideBarProps = {
  size?: SideBarSize
  children: (size: SideBarSize) => ReactNode
}

export const SideBar = ({ size = 'lg', children }: SideBarProps) => {
  const [localSize, setLocalSize] = useState(size)

  return (
    <div
      className={cn('relative h-full w-full overflow-hidden pr-2 pt-1', {
        'w-12': localSize === 'sm',
        'w-[148px]': localSize === 'lg',
      })}
    >
      {children(localSize)}
      <div
        className="absolute bottom-16 left-4 cursor-pointer"
        onClick={() => setLocalSize(localSize === 'sm' ? 'lg' : 'sm')}
      >
        {localSize === 'sm' ? (
          <PanelLeftOpen className="h-4 w-4" />
        ) : (
          <PanelLeftClose className="h-4 w-4" />
        )}
      </div>
    </div>
  )
}
